<template>
	<div>
		<v-toolbar color = "blue-grey lighten-5" class = "index-topbar">
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-fine.png" alt = "music x lab logo" class = "logo"/>
			</v-hover>
      <div style="width: 30px"></div>
			<v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-nyu.png" alt = "music x lab logo" class = "logonyu"/>
			</v-hover>
      <div style="width: 30px"></div>
      <v-hover>
				<img slot-scope="{ hover }" src="../assets/logo-mbzuai.png" alt = "mbzuai logo" class = "logombz"/>
			</v-hover>
    		<!-- <v-toolbar-title>Music X Lab</v-toolbar-title> -->
    		<v-spacer></v-spacer>
    		<v-toolbar-items  style="font-family:'Breve Display';">
      			<v-btn flat :color= "this.$color.primary" style="font-size:1.2rem;font-weight:200; " @click =" $router.push({path:'/index'})"> Home</v-btn>
      			<v-btn flat :color= "this.$color.activate" style="font-size:1.2rem;"  @click =" $router.push({path:'/people'})">People</v-btn>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#575757" flat v-on = "on" style="font-size:1.2rem;" @click =" $router.push({path:'/groups'})">Groups</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, index) in groupInfo" :key = "index" @click="$router.push({name:'Groups',params:{logan:item.logan}})" >
          					<v-list-tile-title>
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
      				</v-list>
				</v-menu>
				<v-menu offset-y open-on-hover>
					<template v-slot:activator = "{on}">
        				<v-btn color= "#657C88" flat v-on = "on" style="font-size:1.2rem;">Demos</v-btn>
					</template>
      				<v-list>
        				<v-list-tile v-for="(item, dindex) in demoInfo" :key = "dindex" @click="$router.push({path: item.address})" >
          					<v-list-tile-title >
								{{ item.name }}
							</v-list-tile-title>
        				</v-list-tile>
                        <v-list-tile flat @click="switchToPage('https://www.cs.cmu.edu/~gxia/demo.html')"><v-list-tile-title >Other Demos</v-list-tile-title></v-list-tile>
      				</v-list>
                    
				</v-menu>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" $router.push({path:'/publications'})">Publications</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('http://blog.musicxlab.com/') ">Blog</v-btn>
				<v-btn :color= "this.$color.primary" flat style="font-size:1.2rem;" @click =" switchToPage('https://github.com/music-x-lab/music-x-lab') ">Github</v-btn>
				<!-- <v-btn flat>News</v-btn> -->
    		</v-toolbar-items>
  		</v-toolbar>
		<v-layout row wrap style = "background:url('https://i.postimg.cc/NGps0dqN/headline.png');" class = "elevation-1">
            <v-flex xs12 class="text-xs-center pt-4 ">
                <div class = "mb-2" :style = "{color:this.$color.primary,fontSize:5.0 + 'rem',fontFamily:'Calluns !important'}">Members</div>
                <div class = "display-1 mb-4" style="color:grey">星星之火 生生不息</div>
            </v-flex>
        </v-layout>
        <v-layout row wrap align-start class ="my-3">
            <v-flex xs2 text-xs-right>
                <v-item-group v-model="peopleSlotWindow" class="shrink mr-4" mandatory tag="v-flex">
                    <v-item v-for="(sl,sl_i) in peopleSlots" :key="sl_i">
                        <div slot-scope="{ active, toggle }" >
                            <v-btn :input-value="active" flat @click="toggle" style = "padding:5px 0;margin:5px 0;">
                                {{sl.abre}}<v-icon :color="sl.logan" class= "ml-2">radio_button_checked</v-icon>
                            </v-btn>
                        </div>
                    </v-item>
                </v-item-group>
            </v-flex>
            <v-flex xs9 text-xs-left>
                <v-window v-model="peopleSlotWindow" class="elevation-1" vertical style="max-width:1400px;min-width:800px;">
                    <v-window-item  v-for="(sl,sl_i) in peopleSlots" :key="sl_i" >
                        <v-card flat>
                            <v-card-text>
                            <v-layout align-center mb-3>
                                <v-icon :color="sl.logan" class="mr-3">radio_button_checked</v-icon>
                                <strong class="title">{{sl.name}}</strong>
                                <v-spacer></v-spacer>
                                <v-icon>people</v-icon>
                            </v-layout>
                            <v-card class = "eleavation-1" v-for="(member,m_id) in sl.members" :key="m_id" >
                                <v-card class="elevation-2 text-xs-center" >
                                    <div style="height:200px" class = "pa-2">
                                        <v-layout align-center fill-height class = "text-xs-left">
                                            <v-flex xs3>
                                                <v-img :src="people[member].picture" height = "170px" width ="170px" class="ml-3" :aspect-ratio="1" contain lazy>
                                                    <template v-slot:placeholder>
                                                        <v-layout fill-height align-center justify-center ma-0>
                                                            <v-progress-circular indeterminate color="purple"></v-progress-circular>
                                                        </v-layout>
                                                    </template>
                                                </v-img>
                                            </v-flex>
                                            <v-flex xs8>
                                                <v-layout row wrap>
                                                    <v-flex xs6>
                                                        <div class="display-1" :style="{color:$color.primary,fontFamily:'Calluns !important'}">{{people[member].name}}</div>
                                                    </v-flex>
                                                    <v-divider></v-divider>
                                                    <v-flex xs6 class ="text-xs-right" id = "people-group">
                                                        <span :style="{color:$color.primary,fontFamily:'Calluns !important'}"  class = "title mr-3" v-if="Object.keys(people[member].groups).length > 0">Teams:</span>
                                                        <template v-for="(lo,l_id) in people[member].groups">
                                                            <v-tooltip top :key="l_id * m_id"  class = "limit-logan-offset">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn :color="lo" fab style="height:30px;width:30px;" v-on="on" ></v-btn>
                                                                </template>
                                                                <span >{{getGroupFromLogan(lo)}}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <div class="subheading my-2" style="max-height:200px;">{{people[member].position + " at " + people[member].school}}</div>
                                                    </v-flex>
                                                    <v-flex xs12 mb-1>
                                                        <v-divider></v-divider>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <div class = "v-btn__content my-1" style="justify-content:left;font-family:Circular;">
                                                            <v-icon left>email</v-icon>
                                                            <span class ="subheading">{{people[member].email}}</span>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                         <div class = "v-btn__content my-1" style="justify-content:left;font-family:Circular;">
                                                            <v-icon left>web</v-icon>
                                                            <a class ="subheading" :href="people[member].website" target="_blank" style="color:black">{{people[member].website}}</a>
                                                        </div>

                                                    </v-flex>
                                                    <v-flex xs12>
                                                         <div class = "v-btn__content my-1" style="justify-content:left;font-family:Circular;">
                                                            <v-icon left>gamepad</v-icon>
                                                            <template v-for="(sk,sk_id) in people[member].skills">
                                                                <span class ="subheading mr-1" :key="sk_id" >{{parseInt(sk_id) < Object.keys(people[member].skills).length - 1 ? sk.charAt(0).toUpperCase() + sk.slice(1) + " ," : sk.charAt(0).toUpperCase() + sk.slice(1)}}</span>
                                                            </template>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>


                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-card>
                            </v-card>
                            </v-card-text>
                        </v-card>
                        </v-window-item>
                    <v-container grid-list-md text-xs-center>
                        <v-layout row wrap class = "mt-4">
                            <v-flex v-for="(card, index) in groupPhotos" :key="index" xs4>
                                <v-hover>
                                    <v-card class="v-card__text" color="grey lighten-4" style="cursor: pointer;"
                                        @click="toggleEnlarge(index)" :class="{ enlarged: card.isEnlarged }" hover >
                                        <v-img :src="card.image" :aspect-ratio="4/3" max-height="90%" max-width="100%" contain lazy>
                                            <template v-slot:placeholder>
                                                <v-layout fill-height align-center justify-center ma-0>
                                                    <v-progress-circular indeterminate color="purple"></v-progress-circular>
                                                </v-layout>
                                            </template>
                                        </v-img>
                                        <v-card-text v-if="!card.isEnlarged" class="pt-4" style="position: relative;min-height:80px;padding-bottom: 0">
                                            <div class="mb-2" :style="{fontFamily: 'Calluns !important', fontSize: '1.6rem', textAlign: 'center'}">{{card.title}}</div>
                                        </v-card-text>
                                        <v-card-text v-if="card.isEnlarged" class="pt-4" style="position: relative;min-height:60px;">
                                            <div class="mb-2" :style="{fontFamily: 'Calluns !important', fontSize: '1.6rem', textAlign: 'center'}">{{card.subtitle}}</div>
                                        </v-card-text>
                                    </v-card>
                                </v-hover>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-window>
            </v-flex>
        </v-layout>


      <div v-if="isAnyPhotoEnlarged" class="background-mask" @click="shrinkAllPhotos"></div>

	</div>
</template>

<script>
export default {
  name: 'People',
  data() {
    return {
        peopleSlotWindow:0,
        defaultPic:"https://i.postimg.cc/GpKN1pgY/2.jpg",
        groupInfo:[{name:"",introPic:"",intro:"",description:"",logan:""}],
		people:[ {alumni: "", email: "", groups: [], id: 1, label: "", name: "", picture: "", position: "", school: "", skills: [],website:""}],
        peopleSlots:[{name:"Faculty",logan:"red",abre:"Faculty",members:[]},{name:"Graduate Students/Visiting Schorlars",logan:"blue",abre:"Graduate Students",members:[]},
                        {name:"Undergraduate",logan:"green",abre:"Undergraduate",members:[]},{name:"Alumni",logan:"pink",abre:"Alumni",members:[]},{name:"Memories",logan:"grey",abre:"Memories",members:[]}],
        demoInfo:[
            {name:"Interactive Rainbow Score", address:"/demo/IRS"}
        ],
        groupPhotos: [{
            title: '2023 autumn: Italy Demo Tour',
            image: "https://s2.loli.net/2024/01/11/4pduU3zbWfYqPQR.jpg",
            subtitle: 'Complete script: (Gus) Hi Teo! (Teo) Hi Gus, long time no see. [Unrecognizable machine failure noise]',
            isEnlarged: false,
        },{
            title: '2023 summer',
            image: "https://s2.loli.net/2024/01/11/RVZckQ2xGu3PtYb.jpg",
            subtitle: 'Featuring the SET puzzle. Here is a SET puzzle for you: [11] (①①) [22] [⑵⑵] (111) [222] [①] {③} (222) [②] {⑶⑶} [⑵⑵⑵]',
            isEnlarged: false,
        },{
            title: '2022: Music AI Concert at Abu Dhabi, hosted by MBZUAI',
            image: "https://s2.loli.net/2023/06/19/n16LExusAyrChdN.jpg",
            subtitle: 'This is a very special summer with wonderful adventures. Thank you, MBZUAI; thank you, my dear friends and students. This is just a prelude!',
            isEnlarged: false,
        },{
            title: '2021 summer: Post-NIME Music X Lab Concert in July',
            image: "https://s2.loli.net/2023/06/19/dMwNYSGIl5sD1Wh.jpg",
            subtitle: '星辰学子，一轮明月。\n' +
                '毕业生们，学海无涯，光阴转瞬，愿精彩前路不忘赤子初心。',
            isEnlarged: false,
        },{
            title: '2020 summer',
            image: "https://s2.loli.net/2023/06/19/pjF37KOU5ht4qIS.jpg",
            subtitle: 'Generation after generation, better music generation.',
            isEnlarged: false,
        },{
            title: '2019 summer',
            image: "https://s2.loli.net/2023/06/19/4XhpwJaW6mOilHG.jpg",
            subtitle: '年年岁岁聚又别，岁岁年年道又同，但有诚心求归途，不辞恒作掌灯人。 毕业生们，再见，记得读书。',
            isEnlarged: false,
        },{
            title: '2018 summer',
            image: "https://i.loli.net/2020/07/26/OH5d2kAynNXcTFC.jpg",
            subtitle: 'Music X Lab\'s first graduation dinner.',
            isEnlarged: false,
        },
        ]
    }
  },
  computed: {
    isAnyPhotoEnlarged() {
      return this.groupPhotos.some(photo => photo.isEnlarged);
    },
  },
  mounted() {
      this.getPeopleInfo()
  },
  props: {
    msg: String
  },
  methods: {
    switchToPage:function(url) {
		window.location.href=url
	},
    toggleEnlarge(index) {
      this.groupPhotos[index].isEnlarged = !this.groupPhotos[index].isEnlarged;
    },
    shrinkAllPhotos() {
      this.groupPhotos.forEach(photo => {
        photo.isEnlarged = false;
      });
    },
    getGroupFromLogan(logan) {
        for(let i in this.groupInfo) {
            if(this.groupInfo[i].logan == logan) {
                return this.groupInfo[i].name
            }
        }
        return ""
    },
    getPeopleInfo() {
        let that = this
        this.$axios.get("/person/id/list").then(function(res) {
            that.people = res.data
            for(let i in that.people) {
                that.people[i].link = ""
                if (that.people[i].website != "" && (that.people[i].website.slice(0,4)).toLowerCase() != "http") {
                    that.people[i].website = "http://" + that.people[i].website
                }
                that.people[i].position = that.people[i].position.charAt(0).toUpperCase() + that.people[i].position.slice(1)
                if(that.people[i].picture == "") 
                    that.people[i].picture = that.defaultPic
                for(let j in that.peopleSlots) {
                    if(that.people[i].label == that.peopleSlots[j].name) {
                        that.peopleSlots[j].members.push(i)
                        break
                    }
                }
            }
		}).catch(function(error) {
			console.log(error)
		})
		this.$axios.get("/group/id/list").then(function(res) {
			console.log(res)
			that.groupInfo = []
			for(let i in res.data) {
				that.groupInfo.push({
					name:res.data[i].name,
					intro:res.data[i].intro,
					introPic:res.data[i].picture,
					description:res.data[i].keywords,
					logan:res.data[i].color
				})
			}
		}).catch(function(error) {
			console.log(error)
		})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.test-class {
    height:auto !important;
}
.limit__height__class .v-list__tile {
    height: auto !important;
}
.limit-logan-offset .v-tooltip__content {
    left:auto !important;
    text-align: left !important;

    
}

.scroll-y { 
    -ms-overflow-style:none;
}
.scroll-y:hover { 
    -ms-overflow-style:-ms-autohiding-scrollbar;
}
.scroll-y::-webkit-scrollbar { 
    width: 0.5vw;
    height: 1px;
    display: none;
}
.scroll-y:hover::-webkit-scrollbar { 
    display: flex;
}
.scroll-y::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}


.avatar-scrolling {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style:none;
    scrollbar-face-color: #657C88;
    transition: all 0.5s;
}
.avatar-scrolling:hover {
    /* opacity: 1; */
    -ms-overflow-style:-ms-autohiding-scrollbar;
    transition: all 0.5s;
}
.avatar-scrolling::-webkit-scrollbar {
    width: 0;
    height: 0;
} 
.avatar-scrolling:hover::-webkit-scrollbar {
    width: 1px;
    height: 0.5vh; 
} 
.avatar-scrolling::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px #657C88;
    background:#657C88;
}
.avatar-el {
    display:flex;
    flex-flow:column;
}
.enlarged {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 90%;
  z-index: 10000;
}
.background-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
</style>
